export default __webpack_public_path__ + "static/media/blog03.00a9cc95.jpg";